import React from 'react';

interface LoadingSpinnerProps {
  /** 自定义类名 */
  className?: string;
  /** SVG 大小 */
  size?: number;
}

/**
 * 加载动画 SVG 组件
 * 基于 Lottie 动画 JSON 转换
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ className, size = 96 }) => {
  return (
    <svg
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      style={{ display: 'block' }}
    >
      <defs>
        <style>{`
          @keyframes spin {
            0% {
              stroke-dashoffset: 0;
              stroke-dasharray: 0, 351.86;
              opacity: 0;
            }
            50% {
              opacity: 1;
            }
            100% {
              stroke-dashoffset: -351.86;
              stroke-dasharray: 315.68, 351.86;
              opacity: 0.35;
            }
          }
          .loading-circle {
            animation: spin 1s linear infinite;
            transform-origin: 32px 32px;
          }
        `}</style>
      </defs>
      <circle
        className="loading-circle"
        cx="32"
        cy="32"
        r="28"
        fill="none"
        stroke="#00c8c8"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LoadingSpinner;
